import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TopMessage from "../components/TopMessage";
import NextStepCard from "../components/NextStepCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExploreIcon from "@mui/icons-material/Explore";

export default function InsightHubGuidanceStep({ isLiveDemo }) {
    // 1. Top Message State (Welcome)
    const [welcomeVisible, setWelcomeVisible] = useState(false);

    // 2. Bottom Message State (Next Step)
    const [nextStepVisible, setNextStepVisible] = useState(false);

    // Global Demo State Access (Simulated logic specific to your app)
    const demoAttempts = parseInt(sessionStorage.getItem('demo_stash_attempts') || "0", 10);

    // Effect: Show Welcome
    useEffect(() => {
        const hasShown = sessionStorage.getItem("insight_hub_welcome_shown");
        if (isLiveDemo && !hasShown) {
            setWelcomeVisible(true);
            sessionStorage.setItem("insight_hub_welcome_shown", "true");
        }
        if (isLiveDemo) {
            sessionStorage.setItem("demo_visited_hub", "true");
            window.dispatchEvent(new Event('demoVisitUpdated'));
        }
    }, [isLiveDemo]);

    // Effect: Show Next Step (Bottom Right)
    useEffect(() => {
        if (isLiveDemo && (demoAttempts === 1 || demoAttempts === 2)) {
            const timer = setTimeout(() => {
                setNextStepVisible(true);
            }, 5000); // 5 seconds delay

            return () => clearTimeout(timer);
        }
    }, [isLiveDemo, demoAttempts]);

    if (!isLiveDemo) return null;

    // Determine Logic/Content for Next Step Card
    const nextStepConfig = demoAttempts === 2 ? {
        title: "Ready for the next step?",
        body: "You've checked out multi-profile comparison! Let's find some competitors to compare against in <b>Platform Scout</b>.",
        buttonText: "Explore Platform Scout",
        buttonLink: "/platform-scout",
        icon: <ExploreIcon />
    } : {
        title: "Ready for the next step?",
        body: "You've analysed a single profile. Now, go back to <b>Social Stash</b> to select multiple profiles for <b>Cross-Platform Comparison</b>.",
        buttonText: "Back to Social Stash",
        buttonLink: "/social-stash",
        icon: <ArrowBackIcon />
    };

    return (
        <>
            <TopMessage
                visible={welcomeVisible}
                title="Welcome to Insight Hub!"
                subtitle="Scroll down to explore the interactive charts and metrics."
            />

            <NextStepCard
                visible={nextStepVisible}
                title={nextStepConfig.title}
                body={nextStepConfig.body}
                buttonText={nextStepConfig.buttonText}
                buttonLink={nextStepConfig.buttonLink}
                icon={nextStepConfig.icon}
            />
        </>
    );
}

// Adding PropTypes
InsightHubGuidanceStep.propTypes = {
    isLiveDemo: PropTypes.bool,
};
